import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';

export const useDsoSwitchToSingleShip = (
  setShipToMultipleAddresses: (value: boolean) => void
) => {
  const queryClient = useQueryClient();
  return useMutation(
    () => {
      return dsoCartService.switchToSingleShip();
    },
    {
      onSuccess: data => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
        setShipToMultipleAddresses(false);
        queryClient.invalidateQueries([
          ServerStateKeysEnum.dsoBillingAddresses,
        ]);
      },
      onError: error => {
        console.error(error);
      },
    }
  );
};
